/**
 * P3-19: TechButton —— 科技按钮（迁移自
 * com.nuclearunicorn.game.ui.TechButtonController + BuildingResearchBtn，
 * js/science.js:2684-2717 / core.js:2402-2404）。
 *
 * 行为对齐：
 * - 名称：controller.getName 产出 HTML（已研究时追加 COMPLETE）
 * - 描述：aria-description 取 model.description
 * - 可见：meta.unlocked；若已研究且 hideResearched 则不渲染
 * - 禁用：已研究或资源不足
 * - tooltip：ButtonModernHelper.getTooltipHTML 直取
 * - 点击：controller.buyItem(modelRef.current, event)
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { useTechButtonModel } from "./useScienceModel";

interface TechButtonProps {
  techName: string;
}

export function TechButton({ techName }: TechButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useTechButtonModel(techName);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
      getSelectedObject={() => modelRef.current}
    />
  );
}
